module.exports = __webpack_public_path__ + "static/media/logo_vechnology.2f1494d4.png";